import { connect } from 'react-redux'
import Questionnaire from '..'
import {
  geStudentQuestionaireResult,
  getSingleRoleQuestionSet,
  getSingleRoleStudentQuestionAnswerSet,
  updateSingleRoleStudentAnswerSet,
} from '../actions'
import { ApplyRole, RejectedRole } from '../../actions'
const mapStateToProps = state => ({})
const mapDispatchToProps = {
  getSingleRoleQuestionSet,
  updateSingleRoleStudentAnswerSet,
  getSingleRoleStudentQuestionAnswerSet,
  ApplyRole,
  geStudentQuestionaireResult,
  RejectedRole,
}
export default connect(mapStateToProps, mapDispatchToProps)(Questionnaire)
